var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0ZM13.207 7.707C13.3892 7.5184 13.49 7.2658 13.4877 7.0036C13.4854 6.7414 13.3802 6.49059 13.1948 6.30518C13.0094 6.11977 12.7586 6.0146 12.4964 6.01233C12.2342 6.01005 11.9816 6.11084 11.793 6.293L7.793 10.293C7.60553 10.4805 7.50021 10.7348 7.50021 11C7.50021 11.2652 7.60553 11.5195 7.793 11.707L11.793 15.707C11.9816 15.8892 12.2342 15.99 12.4964 15.9877C12.7586 15.9854 13.0094 15.8802 13.1948 15.6948C13.3802 15.5094 13.4854 15.2586 13.4877 14.9964C13.49 14.7342 13.3892 14.4816 13.207 14.293L9.914 11L13.207 7.707Z",
    fill: "#414141"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.4c875cb8574ce1bd87b79c11685e73ed.svg";
export { ForwardRef as ReactComponent };